import { notify } from '../../actions/notifications';
import { toggleFavoriteOffersFromHistory } from '../../actions/offersFromHistory';
import { TAddFavoriteResponse, fetchAddFavorite } from '../../repositories/favorites/v1/add-favorite';
import { ENotificationStyle } from '../../types/notifications';
import { TRecentlyViewedOffer } from '../../types/recentlyViewedOffer';
import { TThunkAction } from '../../types/redux';

export const addToFavorite =
  ({ dealType, offerId, entityType }: TRecentlyViewedOffer): TThunkAction<Promise<void>> =>
  async (dispatch, _, { httpApi, logger }) => {
    dispatch(toggleFavoriteOffersFromHistory({ offerId, isFavorite: true }));

    const showError = () =>
      dispatch(notify('Не удалось добавить недавно просмотренное объявление в избранное', ENotificationStyle.Error));

    try {
      const { statusCode, response }: TAddFavoriteResponse = await fetchAddFavorite({
        httpApi,
        parameters: {
          dealType,
          entityId: offerId,
          entityType,
        },
      });

      if (statusCode !== 200) {
        dispatch(toggleFavoriteOffersFromHistory({ offerId, isFavorite: false }));

        showError();
        logger.warning(response.message || 'Fail to add recently viewed to favorites');
      }
    } catch (e) {
      dispatch(toggleFavoriteOffersFromHistory({ offerId, isFavorite: false }));

      showError();
      logger.error(e, {
        description: 'Fail to add recently viewed to favorites',
      });
    }
  };
